import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { ServiceAppointmentItemType } from "@/schemas/index";
import { serviceServicesApi } from "@/services/services/index";

const LayoutPageRequestView = lazy(() => import("./layout/index"));

export type LoaderDataType = ServiceAppointmentItemType;

export const loaderDataRequestView = async (args: any) => {
  try {
    const { requestId } = args.params;

    if (!requestId) {
      throw new Error("REQUEST_ID_REQUIRED");
    }

    const request = await serviceServicesApi.fetchAppointmentById(requestId);

    if (!request) {
      throw new Error("REQUEST_NOT_FOUND");
    }

    return request;
  } catch (err) {
    console.error(err);
    throw new Error("REQUEST_NOT_FOUND");
  }
};

export const routerPageRequestView: RouterItemType = {
  path: "/service/requests/:requestId",
  authorize: true,
  element: <LayoutPageRequestView />,
  loader: loaderDataRequestView,
};
